import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-navy-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <img src="/logo.png" alt="KEEN WISDOM" className="h-24 w-auto mb-4 mix-blend-screen" style={{ filter: 'brightness(1.1) contrast(1.1)' }} />
            <p className="text-gray-300">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">{t.nav.services}</h4>
            <ul className="space-y-2 text-gray-300">
              <li>{language === 'en' ? 'Wealth Management' : '财富管理'}</li>
              <li>{language === 'en' ? 'Tax Planning' : '税务规划'}</li>
              <li>{language === 'en' ? 'Family Office' : '家族办公室'}</li>
              <li>{language === 'en' ? 'Strategic Advisory' : '战略咨询'}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">{t.contact.info.title}</h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>
                {language === 'en' ? 'Tel' : '电话'}: <a href={`tel:${t.contact.info.telephoneValue.replace(/\s/g, '')}`} className="hover:text-gold-400 transition-colors">{t.contact.info.telephoneValue}</a>
              </li>
              <li>WhatsApp: +852 9658 6641</li>
              <li>Email: cs@keenwisdom.com</li>
              <li className="pt-2">
                <a 
                  href={t.contact.info.addressLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gold-400 transition-colors"
                >
                  {t.contact.info.addressValue}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">{t.footer.copyright}</p>
          <p className="text-gray-300 font-medium">{t.footer.website}</p>
          <p className="text-gold-400 font-medium">{t.footer.since}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;